var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeroSmall'),_c('b-container',{staticClass:"mt-5 mb-5"},[_c('h1',{staticClass:"display-1"},[_vm._v("Corporate Responsibility")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }